import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { BottomModal } from "components/common/BottomModal/BottomModal";
import { FontIcon } from "components/common/Icons/FontIcon";
import { useFontList } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Font/FontList/useFontList";
import { useFont } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Font/useFont";
import { TextBox } from "store/features/memeGenerator/types";
import { Option } from "../Option/Option";
import { Content } from "./Content/Content";
import { TitleBar } from "./TitleBar/TitleBar";

interface FontProps {
    textBox: TextBox;
}

export const Font = ({ textBox }: FontProps) => {
    const useFontReturn = useFont();
    const useFontListReturn = useFontList(textBox, useFontReturn.loadMoreGoogleFonts, useFontReturn.close);
    return (
        <>
            <Option icon={<FontIcon />} text={capitalize(translateFunc("font"))} onClick={useFontReturn.open} />
            <BottomModal
                isOpen={useFontReturn.isOpen}
                onClose={useFontReturn.close}
                titleBar={<TitleBar close={useFontReturn.close} />}
                handleScroll={useFontListReturn.handleScroll}
            >
                <Content textBox={textBox} useFontReturn={useFontReturn} useFontListReturn={useFontListReturn} />
            </BottomModal>
        </>
    );
};
